import React, { useState, useEffect, useContext, useCallback, useRef } from 'react';
import {
    MdAddCircle as PlusCircle,
    MdEdit as Pencil,
    MdDelete as Trash2,
    MdClose as X,
    MdWarning as AlertTriangle,
    MdPalette as Palette,
    MdClear as Clear,
  } from 'react-icons/md';
import Modal from 'react-modal';
import Menu from "@components/Menu";
import EmpresaSelect from "@components/EmpresaSelect";
import { HexColorPicker } from 'react-colorful';
import UserContext from "@components/context/userContext";
import categoriesService from "@services/categories";

Modal.setAppElement('#root');

const defaultCategory = {
  idcategoria: 0,
  descricaocategoria: '',
  color: '#000000',
  combustivel: false,
  gas: false,
  arredondamento: false,
  servico: false,
  naomovstock: false,
  pedesemana: false,
  impressora: false,
  tabaco: false,
};

const PREDEFINED_COLORS = [
  { name: 'Vermelho', hex: '#FF0000' },
  { name: 'Verde', hex: '#00FF00' },
  { name: 'Azul', hex: '#0000FF' },
  { name: 'Amarelo', hex: '#FFD700' },
  { name: 'Laranja', hex: '#FFA500' },
  { name: 'Roxo', hex: '#800080' },
  { name: 'Rosa', hex: '#FF69B4' },
  { name: 'Castanho', hex: '#8B4513' },
  { name: 'Cinzento', hex: '#808080' },
  { name: 'Preto', hex: '#000000' },
  { name: 'Branco', hex: '#FFFFFF' },
  { name: 'Turquesa', hex: '#40E0D0' }
];

const CategoryForm = React.memo(({ category, onChange, isNew = false }) => (
  <div className="form-horizontal">
    {isNew && (
      <div className="form-group">
        <label className="col-sm-3 control-label">ID da Categoria</label>
        <div className="col-sm-9">
          <input
            type="number"
            className="form-control"
            value={category.idcategoria}
            onChange={(e) => onChange('idcategoria', parseInt(e.target.value) || 0)}
            min="0"
          />
        </div>
      </div>
    )}
    
    <div className="form-group">
      <label className="col-sm-3 control-label">Nome</label>
      <div className="col-sm-9">
        <input
          type="text"
          className="form-control"
          value={category.descricaocategoria}
          onChange={(e) => onChange('descricaocategoria', e.target.value)}
          placeholder="Nome da categoria"
        />
      </div>
    </div>
    
    {!isNew && (
    <ColorPickerSection
      color={category.color}
      onChange={(color) => onChange('color', color)}
    />)}

    <div className="form-group">
      <div className="col-sm-9">
        <div className="row">
        <div className="col-sm-6">
        <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={category.combustivel}
                  onChange={(e) => onChange('combustivel', e.target.checked)}
                /> Combustível
              </label>
            </div>
            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={category.gas}
                  onChange={(e) => onChange('gas', e.target.checked)}
                /> Gás
              </label>
            </div>
            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={category.servico}
                  onChange={(e) => onChange('servico', e.target.checked)}
                /> Serviço
              </label>
            </div>
            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={category.tabaco}
                  onChange={(e) => onChange('tabaco', e.target.checked)}
                /> Tabaco
              </label>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={category.arredondamento}
                  onChange={(e) => onChange('arredondamento', e.target.checked)}
                /> Arredondamento
              </label>
            </div>
            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={category.naomovstock}
                  onChange={(e) => onChange('naomovstock', e.target.checked)}
                /> Não Mov. Stock
              </label>
            </div>
            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={category.pedesemana}
                  onChange={(e) => onChange('pedesemana', e.target.checked)}
                /> Pedido Semanal
              </label>
            </div>
            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={category.impressora}
                  onChange={(e) => onChange('impressora', e.target.checked)}
                /> Impressora
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
));

const ColorPickerSection = React.memo(({ color, onChange }) => {
  const [showCustomPicker, setShowCustomPicker] = useState(false);

  return (
    <div className="form-group">
      <label className="col-sm-3 control-label">Cor</label>
      <div className="col-sm-9">
        <div className="color-picker-grid">
          {PREDEFINED_COLORS.map((presetColor) => (
            <button
              key={presetColor.hex}
              onClick={() => {
                onChange(presetColor.hex);
                setShowCustomPicker(false);
              }}
              className={`color-swatch ${color === presetColor.hex ? 'active' : ''}`}
              style={{ backgroundColor: presetColor.hex }}
              title={presetColor.name}
            />
          ))}
        </div>
        
        <button
          onClick={() => setShowCustomPicker(!showCustomPicker)}
          className="btn btn-secondary"
        >
          <Palette size={20} className="btn-icon" />
          {showCustomPicker ? 'Esconder Seletor de Cor' : 'Cor Personalizada'}
        </button>
        
        {showCustomPicker && (
          <div className="custom-color-picker">
            <HexColorPicker color={color} onChange={onChange} />
            <div className="input-group" style={{ marginTop: '10px', width: '200px' }}>
              <span className="input-group-addon">
                <div 
                  style={{
                    width: '20px',
                    height: '20px',
                    backgroundColor: color,
                    border: '1px solid #ddd',
                    borderRadius: '2px'
                  }}
                />
              </span>
              <input
                type="text"
                value={color}
                onChange={(e) => onChange(e.target.value)}
                className="form-control"
                pattern="^#[0-9A-Fa-f]{6}$"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

function App() {
    const profile = useContext(UserContext);
    
  const [categories, setCategories] = useState([]);
  const [editingCategory, setEditingCategory] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const [newCategory, setNewCategory] = useState({ ...defaultCategory });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const searchInputRef = useRef(null);

  const fetchCategories = useCallback(async () => {
    try {
      setIsLoading(true);
      const data = await categoriesService.get(profile.idEmpresaSec);
      if (Array.isArray(data)) {
        const formattedCategories = data.map((item) => ({
          idcategoria: parseInt(item.idcategoria),
          descricaocategoria: item.descricaocategoria,
          color: item.color || '#000000',
          combustivel: item.combustivel === 't',
          gas: item.gas === 't',
          arredondamento: item.arredondamento === 't',
          servico: item.servico === 't',
          naomovstock: item.naomovstock === 't',
          pedesemana: item.pedesemana === 't',
          impressora: item.impressora === 't',
          tabaco: item.tabaco === 't',
          idempresa: profile.idEmpresaSec
        }));
        setCategories(formattedCategories.sort((a, b) => a.idcategoria - b.idcategoria));
      } else {
        setCategories([]);
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao carregar categorias');
      setCategories([]);
    } finally {
      setIsLoading(false);
    }
  }, [profile.idEmpresaSec]);

  useEffect(() => {
    import('./list.css').then(() => {});
    fetchCategories();
  }, [fetchCategories]);

  // Keyboard shortcut for search (Cmd/Ctrl + K)
  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        if (searchInputRef.current) {
          searchInputRef.current.focus();
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  const handleCreate = async () => {
    try {
      if (!newCategory.idcategoria) {
        setError('O ID da categoria é obrigatório');
        return;
      }

      if (!newCategory.descricaocategoria.trim()) {
        setError('O nome da categoria é obrigatório');
        return;
      }

      const categoryExists = categories.some(cat => cat.idcategoria === newCategory.idcategoria);
      if (categoryExists) {
        setError('Este ID de categoria já existe. Por favor, escolha outro ID.');
        return;
      }

      const responseData = await categoriesService.set({
        idempresa: profile.idEmpresaSec,
        idcategoria: newCategory.idcategoria.toString(),
        descricaocategoria: newCategory.descricaocategoria,
        combustivel: newCategory.combustivel ? 't' : 'f',
        gas: newCategory.gas ? 't' : 'f',
        arredondamento: newCategory.arredondamento ? 't' : 'f',
        servico: newCategory.servico ? 't' : 'f',
        naomovstock: newCategory.naomovstock ? 't' : 'f',
        pedesemana: newCategory.pedesemana ? 't' : 'f',
        impressora: newCategory.impressora ? 't' : 'f',
        tabaco: newCategory.tabaco ? 't' : 'f'
      });
      
      if (responseData === 'NOK') {
        throw new Error('Este ID de categoria já existe. Por favor, escolha outro ID.');
      }

      setNewCategory({ ...defaultCategory });
      setIsModalOpen(false);
      setError(null);
      await fetchCategories();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao criar categoria');
    }
  };

  const handleEdit = (category) => {
    setEditingCategory(category);
    setIsEditModalOpen(true);
  };

  const handleUpdate = async () => {
    if (!editingCategory) return;

    try {
      const responseData = await categoriesService.set({
        idempresa: profile.idEmpresaSec,
        idcategoria: editingCategory.idcategoria.toString(),
        descricaocategoria: editingCategory.descricaocategoria,
        combustivel: editingCategory.combustivel ? 't' : 'f',
        gas: editingCategory.gas ? 't' : 'f',
        arredondamento: editingCategory.arredondamento ? 't' : 'f',
        servico: editingCategory.servico ? 't' : 'f',
        naomovstock: editingCategory.naomovstock ? 't' : 'f',
        pedesemana: editingCategory.pedesemana ? 't' : 'f',
        impressora: editingCategory.impressora ? 't' : 'f',
        tabaco: editingCategory.tabaco ? 't' : 'f',
        color: editingCategory.color
      });
      
      if (responseData.status === 'NOK') {
        throw new Error(responseData.message || 'Erro ao atualizar categoria');
      }

      setCategories(categories.map(c => 
        c.idcategoria === editingCategory.idcategoria ? editingCategory : c
      ));
      setIsEditModalOpen(false);
      setEditingCategory(null);
      setError(null);
      
      await fetchCategories();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao atualizar categoria');
    }
  };

  const handleDeleteModal = (categoryId) => {
    setCategoryToDelete(categoryId);
    setDeleteModalOpen(true);
  };

  const handleDelete = async () => {
    if (!categoryToDelete) return;

    try {
      const data = await categoriesService.unset(profile.idEmpresaSec, categoryToDelete);
      
      if (data.status === 'OK') {
        setCategories(categories.filter(c => c.idcategoria !== categoryToDelete));
        setDeleteModalOpen(false);
        setCategoryToDelete(null);
        setError(null);
      } else {
        throw new Error(data.message || 'Erro ao eliminar categoria');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao eliminar categoria');
    }
  };

  const getActiveTags = (category) => {
    const tags = [];
    if (category.combustivel) tags.push('Combustível');
    if (category.arredondamento) tags.push('Arredondamento');
    if (category.servico) tags.push('Serviço');
    if (category.naomovstock) tags.push('Não Mov. Stock');
    if (category.pedesemana) tags.push('Pedido Semanal');
    if (category.gas) tags.push('Gás');
    if (category.impressora) tags.push('Impressora');
    if (category.tabaco) tags.push('Tabaco');
    return tags;
  };

  const filteredCategories = categories.filter(category => {
    const searchLower = searchQuery.toLowerCase();
    const tags = getActiveTags(category);
    
    return (
      category.idcategoria.toString().includes(searchQuery) ||
      category.descricaocategoria.toLowerCase().includes(searchLower) ||
      tags.some(tag => tag.toLowerCase().includes(searchLower))
    );
  });

  return (
    <div>
        <Menu />
        <div className="fullContainer" style={{ maxWidth: '100%' }}>
            <div className="col-xs-12">
                <ol
                style={{
                    textAlign: 'left',
                    marginTop: '75px',
                }}
                className="breadcrumb"
                >
                <li>
                    <a href="http://eposgestofinal.com/index.php">Portal</a>
                </li>
                <li className="active">Gestão de Categorias</li>
                </ol>
            </div>
        </div>
        <EmpresaSelect />
        <div className="fullContainer" style={{ padding: '20px', maxWidth: '100%' }}>
        <div className="page-header">
            <div className="row">
            <div className="col-sm-6">
                <h1>Categorias</h1>
            </div>
            <div className="col-sm-6 text-right">
                <button
                onClick={() => setIsModalOpen(true)}
                className="btn btn-primary btn-lg"
                >
                <PlusCircle size={24} className="btn-icon" />
                Nova Categoria
                </button>
            </div>
            </div>
        </div>

        {!isLoading && (
          <div className="stats-container">
            <div className="stat-card">
              <div className="stat-value">{categories.length}</div>
              <div className="stat-label">Total de Categorias</div>
            </div>
            <div className="stat-card">
              <div className="stat-value">{filteredCategories.length}</div>
              <div className="stat-label">Resultados</div>
            </div>
          </div>
        )}

        <div className="search-wrapper">
          <div className="search-container">
            <input
              ref={searchInputRef}
              type="text"
              className="form-control search-input"
              placeholder="Pesquisar por nome, ID ou tags..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            {searchQuery && (
              <button
                className="search-clear-btn"
                onClick={() => setSearchQuery('')}
                title="Limpar pesquisa"
              >
                <Clear size={20} />
              </button>
            )}
            <div className="search-shortcut">
              <kbd>⌘K</kbd>
            </div>
          </div>
          {searchQuery && (
            <div className="search-results-info">
              <span className="results-badge">
                {filteredCategories.length} {filteredCategories.length === 1 ? 'resultado' : 'resultados'}
              </span>
              {filteredCategories.length === 0 && (
                <span className="no-match-text">Nenhuma correspondência encontrada</span>
              )}
            </div>
          )}
        </div>

        {error && (
            <div className="alert alert-danger">
            <AlertTriangle size={24} className="btn-icon" />
            {error}
            </div>
        )}

        {isLoading ? (
            <div className="loading">
            <div style={{ 
                width: '48px', 
                height: '48px', 
                border: '4px solid #e5e7eb', 
                borderTopColor: '#4f46e5',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                margin: '0 auto 16px'
            }} />
            <p>Carregando categorias...</p>
            </div>
        ) : (
            <div>
            {filteredCategories.length === 0 ? (
                <div className="no-results">
                <p>Nenhuma categoria encontrada</p>
                </div>
            ) : (
                filteredCategories.map((category) => (
                <div key={category.idcategoria} className="category-card">
                    <div className="category-header">
                    <div
                        className="color-circle"
                        style={{ backgroundColor: category.color }}
                    />
                    <span className="category-id">#{category.idcategoria}</span>
                    <h3 className="category-name">{category.descricaocategoria}</h3>
                    <div className="pull-right">
                        <button
                        onClick={() => handleEdit(category)}
                        className="btn btn-link"
                        >
                        <Pencil size={24} className="text-primary" />
                        </button>
                        <button
                        onClick={() => handleDeleteModal(category.idcategoria)}
                        className="btn btn-link"
                        >
                        <Trash2 size={24} className="text-danger" />
                        </button>
                    </div>
                    </div>
                    <div>
                    {category.combustivel && (
                        <span className="tag tag-blue">Combustível</span>
                    )}
                    {category.gas && (
                        <span className="tag tag-red">Gás</span>
                    )}
                    {category.arredondamento && (
                        <span className="tag tag-green">Arredondamento</span>
                    )}
                    {category.servico && (
                        <span className="tag tag-purple">Serviço</span>
                    )}
                    {category.naomovstock && (
                        <span className="tag tag-yellow">Não Mov. Stock</span>
                    )}
                    {category.pedesemana && (
                        <span className="tag tag-pink">Pedido Semanal</span>
                    )}
                    {category.impressora && (
                        <span className="tag tag-indigo">Impressora</span>
                    )}
                    {category.tabaco && (
                        <span className="tag tag-orange">Tabaco</span>
                    )}
                    </div>
                </div>
                ))
            )}
            </div>
        )}

        <Modal
            isOpen={isModalOpen}
            onRequestClose={() => {
            setIsModalOpen(false);
            setNewCategory({ ...defaultCategory });
            setError(null);
            }}
            className="modal-content"
            overlayClassName="modal-overlay"
            contentLabel="Nova Categoria"
        >
            <div className="modal-header">
            <h2 className="modal-title">Nova Categoria</h2>
            <button
                onClick={() => {
                setIsModalOpen(false);
                setNewCategory({ ...defaultCategory });
                setError(null);
                }}
                className="close"
            >
                <X size={24} />
            </button>
            </div>
            <div className="modal-body">
            <CategoryForm
                category={newCategory}
                onChange={(field, value) => setNewCategory({ ...newCategory, [field]: value })}
                isNew={true}
            />
            </div>
            <div className="modal-footer">
            <button
                onClick={() => {
                setIsModalOpen(false);
                setNewCategory({ ...defaultCategory });
                setError(null);
                }}
                className="btn btn-primary btn-lg"
            >
                Cancelar
            </button>
            <button
                onClick={handleCreate}
                className="btn btn-success btn-lg"
            >
                Criar
            </button>
            </div>
        </Modal>

        <Modal
            isOpen={isEditModalOpen}
            onRequestClose={() => {
            setIsEditModalOpen(false);
            setEditingCategory(null);
            }}
            className="modal-content"
            overlayClassName="modal-overlay"
            contentLabel="Editar Categoria"
        >
            {editingCategory && (
            <>
                <div className="modal-header">
                <h2 className="modal-title">Editar Categoria</h2>
                <button
                    onClick={() => {
                    setIsEditModalOpen(false);
                    setEditingCategory(null);
                    }}
                    className="close"
                >
                    <X size={24} />
                </button>
                </div>
                <div className="modal-body">
                <CategoryForm
                    category={editingCategory}
                    onChange={(field, value) => setEditingCategory({ ...editingCategory, [field]: value })}
                />
                </div>
                <div className="modal-footer">
                <button
                    onClick={() => {
                    setIsEditModalOpen(false);
                    setEditingCategory(null);
                    }}
                    className="btn btn-primary btn-lg"
                >
                    Cancelar
                </button>
                <button
                    onClick={handleUpdate}
                    className="btn btn-success btn-lg"
                >
                    Salvar
                </button>
                </div>
            </>
            )}
        </Modal>

        <Modal
            isOpen={deleteModalOpen}
            onRequestClose={() => {
            setDeleteModalOpen(false);
            setCategoryToDelete(null);
            }}
            className="modal-content"
            overlayClassName="modal-overlay"
            contentLabel="Confirmar Eliminação"
        >
            <div className="modal-header">
            <h2 className="modal-title">Confirmar Eliminação</h2>
            <button
                onClick={() => {
                setDeleteModalOpen(false);
                setCategoryToDelete(null);
                }}
                className="close"
            >
                <X size={24} />
            </button>
            </div>
            <div className="modal-body">
            <p>Tem certeza que deseja eliminar esta categoria?</p>
            </div>
            <div className="modal-footer">
            <button
                onClick={() => {
                setDeleteModalOpen(false);
                setCategoryToDelete(null);
                }}
                className="btn btn-primary btn-lg"
            >
                Cancelar
            </button>
            <button
                onClick={handleDelete}
                className="btn btn-danger btn-lg"
            >
                Eliminar
            </button>
            </div>
        </Modal>
        </div>
    </div>
  );
}

export default App;